import React from 'react';

interface ISortIconProps {
  fill?: string;
  size?: number;
}

function SortIcon({ 
  fill = '#333333', 
  size = 24
}: ISortIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 18H9V16H3V18ZM3 6V8H21V6H3ZM3 13H15V11H3V13Z" fill={fill} />
    </svg>
  );
}

export default SortIcon;
